import {
    type StartEventResponseType,
    type StartEventRequestType
} from "./type";
import {
    request
} from "../request";

const StartEvent = async (params: StartEventRequestType): Promise<StartEventResponseType> => {
    return await request("/events/startEvent", {
        body: JSON.stringify(params),
        method: "POST"
    }) as StartEventResponseType;
};

export default StartEvent;
